import * as React from "react";
import { forwardRef } from "react";
const SvgOpenExternal = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	viewBox: "0 0 34 34",
	fill: "currentColor",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M30.2,30.2H3.8V3.8H17V0H3.8C1.7,0,0,1.7,0,3.8v26.4C0,32.3,1.7,34,3.8,34h26.4c2.1,0,3.8-1.7,3.8-3.8V17h-3.8 V30.2z M20.8,0v3.8h6.8L9,22.3l2.7,2.7L30.2,6.4v6.8H34V0H20.8z" }));
const ForwardRef = forwardRef(SvgOpenExternal);
export default ForwardRef;
